import { MatxLoadable } from "matx";
import { isMdScreen, getQueryParam } from "utils";

const MedicalP = MatxLoadable({
  //loader: () => import("./ExtracurricularCoursesAdmin.jsx")
  loader: () => import("./Inicio.jsx")
});

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: true
    },
    leftSidebar: {
      show: true,
      mode: isMdScreen() ? "close" : "full"
    }
  },
  likeDislikeButtons: { show: false }
};

const Medical = [
  {
    exact: true,
    path: "/MedicalAppointment",
    component: MedicalP,
    settings
  },
];

export default Medical;